export const GTM_KEY = process.env.REACT_APP_GOOGLE_TAG_MANAGER_KEY;

export function addGoogleTagManager() {
  if (document.getElementById("gtm-script")) {
    return;
  }
  // add GTM
  const script = document.createElement("script");
  script.id = "gtm-script";
  script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id=' + i + dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${GTM_KEY}');
  `;
  document.head.appendChild(script);

  // Add noscript fallback
  const noscript = document.createElement("noscript");
  noscript.id = "gtm-noscript";
  noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_KEY}"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
  document.body.insertBefore(noscript, document.body.firstChild);
}
